import { createAction } from '@reduxjs/toolkit'

import { ObjectSizeMapping } from 'types/GlobalNormalizedRent'

// tryGetObjectSizeMappings
export const getObjectSizeMappings = createAction('get_object_size_mappings')
export const getObjectSizeMappingsSuccess = createAction<{
  customerId: string
  mappings: ObjectSizeMapping[]
}>('get_object_size_mappings_success')
export const getObjectSizeMappingsFailed = createAction(
  'get_object_size_mappings_failed'
)

// tryCreateObjectSizeMapping
export const createObjectSizeMapping = createAction(
  'create_object_size_mapping'
)
export const createObjectSizeMappingSuccess = createAction<ObjectSizeMapping>(
  'create_object_size_mapping_success'
)
export const createObjectSizeMappingFailed = createAction(
  'create_object_size_mapping_failed'
)

// tryDeleteObjectSizeMapping
export const deleteObjectSizeMapping = createAction(
  'delete_object_size_mapping'
)
export const deleteObjectSizeMappingSuccess = createAction<{
  customerId: string
  mappingId: string
}>('delete_object_size_mapping_success')
export const deleteObjectSizeMappingFailed = createAction(
  'delete_object_size_mapping_failed'
)
